import credentialsList from 'generated/credentials.json';
import { CredentialType } from 'handlers/yourName';

const CREDENTIAL_TIER_MAP = new Map<string, number>();
const LOWEST_CREDENTIAL_TIER = 4;

Object.entries(credentialsList).forEach(([tierName, credentials]) => {
  const tierNumber = parseInt(tierName.replace('tier', ''), 10);
  credentials.forEach((credential: string) => {
    CREDENTIAL_TIER_MAP.set(credential, tierNumber);
  });
});

export const CREDENTIALS_REGEX = /^[A-Za-z ,()/-]{2,}$/;

export const getAllCredentials = (): string[] => Object.values(credentialsList).flat().sort();

const getCredentialTier = (credential: string): number => CREDENTIAL_TIER_MAP.get(credential) ?? LOWEST_CREDENTIAL_TIER;

export const getHighestTierCredential = (credentials: string): string => {
  const credentialList = credentials.split(',').map((cred) => cred.trim());

  return credentialList.reduce((highest, current) => {
    const currentTier = getCredentialTier(current);
    const highestTier = getCredentialTier(highest);

    return currentTier < highestTier ? current : highest;
  }, credentialList[0]);
};

export const getValidatedCredentials = (credentials?: string) => {
  if (!credentials || credentials === '') return [];

  const allCredentials = getAllCredentials();
  const userCredentials = credentials.toLowerCase();
  const normalizeCredential = (credential: string) => credential.toLowerCase().replace(/[^a-zA-Z]/g, '');
  const credentialMap = new Map(allCredentials.map((original) => [normalizeCredential(original), original]));
  const isValidCredential = (credential: string) => credentialMap.has(credential);

  const listCredentials = userCredentials
    .split(',')
    .map((credential: string) => credential.trim().replace(/[^a-zA-Z]/g, ''))
    .filter((credential: string) => credential !== '');

  const validCredentials = Array.from(
    new Set(listCredentials.filter(isValidCredential).map((credential) => credentialMap.get(credential)!)),
  );

  return validCredentials;
};

export const getCredentialType = (
  noCredentialsSelected: boolean,
  haveCredentialsChanged: boolean,
  credentialsToStore?: string,
) => {
  if (noCredentialsSelected) return CredentialType.NoCredential;
  if (credentialsToStore === CredentialType.Other) return CredentialType.Other;

  // Re-enable the credentials list if the user previously selected "other" and then decides to update their credentials again.
  if (haveCredentialsChanged) return CredentialType.Normal;
};
